import axios from 'axios';
import { RequestAdmissionFormModel } from 'app/edozvola/cases/request-admission/request-admission.model';
import { ERRORS } from 'app/config/constants';
import { showToast } from 'app/shared/util/toast.util';
import { toast } from 'react-toastify';

const caseBaseUrl = '/api/cases';

export const fetchRequestAdmission = async (idCase: string): Promise<RequestAdmissionFormModel> => {
  if (idCase) {
    return await new Promise(resolve => {
      axios.get(`${ caseBaseUrl }/request-admission/${ idCase }`).then(response => resolve(response.data));
    });
  }
};

export const saveRequestAdmission = async (idCase: string, requestAdmissionFormModel: RequestAdmissionFormModel): Promise<any> => {
  return await new Promise(resolve => {
    axios
      .post(`${ caseBaseUrl }/request-admission/${ idCase }`, requestAdmissionFormModel)
      .then(response => resolve(response.data))
      .catch(error => {
        if (Object.values(ERRORS).includes(error.data?.message)) {
          showToast(toast.error, error.data?.message);
        } else {
          showToast(toast.error, ERRORS.GENERIC_ERROR);
        }
      });
  });
};
